import { render } from "./nodeTree.vue?vue&type=template&id=5fc37bfd&scoped=true&ts=true"
import script from "./nodeTree.vue?vue&type=script&lang=ts"
export * from "./nodeTree.vue?vue&type=script&lang=ts"

import "./nodeTree.vue?vue&type=style&index=0&id=5fc37bfd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc37bfd"]])

export default __exports__